import type { Observable as ObservableType } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import type { EstimationConfig } from '../../model/types';
import fetch from '../../rest/estimation-config';
import type { ResponseGQL } from '../../rest/estimation-config/types';
import { getBaseUrl, getBoardId } from '../../state/selectors/base';
import type { MiddlewareAPI } from '../../state/types';

const fetchEstimationConfig = (store: MiddlewareAPI): ObservableType<EstimationConfig> => {
	const state = store.getState();
	const baseUrl = getBaseUrl(state);
	const boardId = getBoardId(state);

	return fetch(baseUrl, boardId).map((result: ResponseGQL) => {
		if (result.errors) {
			// @ts-expect-error - TS2345 - Argument of type 'ErrorGQL[]' is not assignable to parameter of type 'string'.
			throw new Error(result.errors);
		}
		if (!result.data || !result.data.agile) {
			throw new Error('No data returned.');
		}
		return result.data.agile.board.estimation;
	});
};

export default fetchEstimationConfig;
